<template>
  <div
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading="isLoading"
  >
    <h4 class="form-title">Stock Request Information</h4>
    <el-row
      type="flex"
      :gutter="15"
      v-for="(request, index) in batch"
      :key="index"
    >
      <el-form
        :model="request"
        ref="requestForm"
        :rules="rules"
        class="multiple-form"
      >
        <a
          v-if="batch.length > 1"
          href="#"
          @click.prevent="remove(index)"
          class="item-remover"
          title="Remove this item."
          ><span class="el-icon-close"></span
        ></a>
        <el-col :sm="8">
          <el-form-item label="Part" prop="part_id">
            <el-select
              v-model="request.part_id"
              filterable
              placeholder="Please enter a Part Number"
              @change="getInfo(index)"
              v-if="is_new"
            >
              <el-option
                v-for="part in useableParts(index)"
                :key="part.id"
                :label="part.part_no"
                :value="part.id"
              ></el-option>
            </el-select>
            <el-input
              v-else
              :readonly="true"
              row="4"
              v-model="request.part_no"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="8">
          <el-form-item label="Description" prop="description">
            <el-input
              readonly
              type="text"
              v-model="request.description"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-form-item v-show="part.id" label="Part Supplier">
      <el-input readonly v-model="part.supplier_name"></el-input>
    </el-form-item> -->
        <el-col :sm="8">
          <el-form-item label="Quantity" prop="quantity">
            <el-input-number
              :readonly="is_readOnly"
              :disabled="is_readOnly"
              v-model.number="request.quantity"
              :controls="false"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <div class="d-flex mt-2">
      <el-button
        size="small"
        type="primary"
        :disabled="isLoading"
        v-if="is_new"
        @click="addItem"
        >Add Item to Batch</el-button
      >
      <el-button
        size="small"
        type="primary"
        :disabled="isLoading"
        v-if="!is_readOnly"
        @click="submit"
        >Save</el-button
      >
      <el-button size="small" @click="cancel">Cancel</el-button>
      <el-button
        v-show="is_admin && request.request_status == 'For Approval'"
        title="Approve Request"
        @click="itemApprove(1)"
        size="small"
        type="success"
        icon="el-icon-check"
        >Approve Request</el-button
      >
      <el-button
        v-show="is_admin && request.request_status == 'For Approval'"
        title="Disapprove Request"
        @click="itemApprove(2)"
        size="small"
        type="danger"
        icon="el-icon-close"
        >Disapprove Request</el-button
      >
    </div>
  </div>
</template>

<script>
import Request from "@/models/StockRequest";
import Part from "@/models/Part";
import socket from "@/socket";

export default {
  name: "request_info",
  computed: {
    is_admin() {
      return this.$store.getters["auth/user"].user_type == 1 ? true : false;
    },
    is_new() {
      return this.request.id ? false : true;
    },
    selectedIds() {
      return this.batch.map(o => o.part_id);
    }
  },
  data() {
    let rules = Request.rules();
    if (!this.is_new) {
      rules.part_id.push({
        validator: (rule, value, callback) => {
          if (value) {
            let same = this.batch.filter(o => {
              return o.part_id == value;
            });
            if (same.length > 1) {
              callback(new Error("Part already added in this batch."));
            } else {
              Request.validate(value).then(resp => {
                if (resp.code == 200) {
                  callback();
                } else {
                  callback(
                    new Error("Stock Request already exist for this part.")
                  );
                }
              });
            }
          } else {
            callback();
          }
        },
        trigger: "change"
      });
    }

    return {
      batch: [new Request()],
      request: new Request(),
      rules: rules,
      isLoading: false,
      part: new Part(),
      is_disabled: true,
      is_readOnly: false,
      parts: []
    };
  },
  methods: {
    cancel() {
      this.$router.push({ name: "stockrequest" });
    },
    remove(index) {
      this.batch.splice(index, 1);
    },
    submit() {
      this.$confirm("Are you sure you want to save this stock request?", {
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      })
        .then(() => {
          var forms = this.$refs["requestForm"];
          // var submitBatch = false;
          let validForms = 0;
          for (let form of forms) {
            form.validate(valid => {
              if (!valid) {
                return false;
              }
              validForms++;
              // submitBatch = true;
              if (validForms == forms.length) {
                // console.log("submit all");
                if (this.is_new) {
                  // if (submitBatch) {
                  var promises = [];
                  let _resp = null;
                  for (let request of this.batch) {
                    var obj = {
                      ...request,
                      requested_by_id: this.$store.getters["auth/user"].id
                    };
                    promises.push(
                      Request.create(obj).then(resp => {
                        // console.log(resp);
                        // this.send_notification(resp);
                        _resp = resp;
                      })
                    );
                  }

                  Promise.all(promises).then(() => {
                    this.$notify({
                      type: "success",
                      message: "Stock Requests saved successfully.",
                      position: "bottom-right"
                    });
                    this.send_notification(_resp);
                    this.$router.push({
                      name: "stockrequest"
                    });
                  });
                  // }
                } else {
                  // update quantity
                  this.$store
                    .dispatch("stockrequest/approve", {
                      id: this.request.id,
                      quantity: this.request.quantity,
                      status: 0
                    })
                    .then(resp => {
                      if (resp) {
                        this.isLoading = false;
                        this.$router.push({ name: "stockrequest" });
                        this.$notify({
                          type: "success",
                          message: `Stock Request updated.`,
                          position: "bottom-right"
                        });
                      }
                    });
                }
              }
            });
          }
        })
        .catch(() => {});
    },
    getInfo(index) {
      var item = this.batch[index];
      if (item) {
        // check if part is already added in the batch

        Part.fetch(item.part_id).then(resp => {
          if (resp) {
            item._part = resp;
            item.quantity = 0;
            item.description = resp.description;
          }
        });
      }
    },
    itemApprove(status) {
      var type = status == 1 ? "approve" : "disapprove";
      this.$confirm(`Are you sure you want to ${type} this request?`, {
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      })
        .then(() => {
          this.isLoading = true;
          this.$store
            .dispatch("stockrequest/approve", {
              id: this.request.id,
              quantity: this.request.quantity,
              status: status
            })
            .then(() => {
              this.isLoading = false;
              this.$router.push({ name: "stockrequest" });
              this.$notify({
                type: "success",
                message: `Stock Request ${type}.`,
                position: "bottom-right"
              });
            });
        })
        .catch(() => {});
    },
    send_notification(response) {
      socket.emit("send_notification", {
        sendto: "admin",
        channel: `room-channel.${response.notification.notify_to_id}`,
        data: response.notification
      });
    },
    addItem() {
      this.batch.push(new Request());
    },
    useableParts(index) {
      let parts = this.parts.filter(o => {
        return (
          this.selectedIds.filter(f => {
            return f == o.id;
          }).length == 0
        );
      });

      let formPart = this.batch[index];
      if (formPart && formPart.part_id) {
        let part = this.parts.find(o => o.id == formPart.part_id);
        parts.push(part);
      }
      return parts;
    }
  },
  mounted() {
    this.isLoading = true;

    if (this.$route.params && this.$route.params.id) {
      this.is_readOnly = true;
      Request.fetch(this.$route.params.id).then(resp => {
        if (resp && resp.id) {
          this.request = new Request(resp);
          if (this.request.request_status == "For Approval") {
            this.is_readOnly = false;
          }
          this.batch = [this.request];
        }
      });
    }

    Part.getGlossary().then(list => {
      this.parts = list;
      if (this.$route.query && this.$route.query.part_id) {
        // this.request.part_id = parseInt(this.$route.query.part_id);
        // this.getInfo(parseInt(this.$route.query.part_id));
        const part = this.parts.find(o => {
          return o.id == this.$route.query.part_id;
        });
        // console.log(part);
        var request = new Request({
          part_id: part.id,
          part_no: part.part_no,
          quantity: 0,
          description: part.description
        });
        this.batch = [request];
      }
      this.isLoading = false;
    });
  }
};
</script>

<style lang="scss" scoped>
.item-remover {
  position: absolute;
  top: 0;
  right: 15px;
  color: #f56c6c;
  z-index: 150;
  &:hover {
    cursor: pointer;
  }
}
.multiple-form {
  width: 100%;
  &:hover {
    background: #eee;
  }
}
</style>
